export default "__VITE_ASSET__M98IfCjV__"